import Component from 'navigation/component/Component';
import store from 'store/store';
import BlockProducts from 'sections/catalog/partials/BlockProducts';
import HomeMedia from './HomeMedia';
import HomeDiptych from './HomeDiptych';
import HomeLinks from './HomeLinks';
class HomeBlocks extends Component {
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            homeMedia: ['.home-media', HomeMedia],
            homeDiptych: ['.home-diptych', HomeDiptych],
            homeLinks: ['.home-links', HomeLinks],
            homeProducts: ['.block-products', BlockProducts]
        };
    }
    initialized() {
        this.offsets = [];
        this.headerBlocks = Array.from(this.el.children).filter(block => {
            return block.hasAttribute('data-header');
        });
        super.initialized();
    }
    getModuleParams(el, componentConstructor) {
        {
            return {
                parent: this.parent,
            };
        }
    }
    bindEvents(add = true) {
        super.bindEvents(add);
        if (add) {
            this.intersectionObserver = new IntersectionObserver(this.onIntersection, { rootMargin: '-4% 0px -95% 0px' });
            this.headerBlocks.forEach(block => this.intersectionObserver.observe(block));
        }
        else {
            this.intersectionObserver.disconnect();
        }
    }
    onIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting)
                this.currentTarget = entry.target;
            else if (entry.target === this.currentTarget)
                this.currentTarget = null;
        });
        if (this.parent.pageManager.state.transitioning)
            return;
        const value = this.currentTarget?.getAttribute('data-header');
        store.headerVariants.set(value === 'light' || value === 'dark' ? [value, 'transparent'] : ['solid']);
    };
    resize() {
        super.resize();
    }
    flush() {
        super.flush();
        store.darkPage.set(false);
    }
}
export default HomeBlocks;
